export default __webpack_public_path__ + "static/media/partner (12).505a36d5.png";